import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '@/views/Error404'
import Home from '@/views/Home'
import Doit from '@/views/Doit'
import Full from '@/views/FullService'
import Resources from '@/views/Resources'
import ResourceLinks from '@/views/ResourceLinks.vue'
import Faq from '@/views/Faq'
import FaqA from '@/views/faqs/FaqA'
import FaqB from '@/views/faqs/FaqB'
import FaqC from '@/views/faqs/FaqC'
import FaqD from '@/views/faqs/FaqD'
import FaqE from '@/views/faqs/FaqE'
import FaqF from '@/views/faqs/FaqF'
import FaqG from '@/views/faqs/FaqG'
import FaqH from '@/views/faqs/FaqH'
import FaqI from '@/views/faqs/FaqI'
import CostEstimator from '@/views/Cost-estimator'
import ContactUs from '@/views/Contactus'
import ComplianceWizard from '@/views/ComplianceWizard'
import Prices from '@/views/Prices'
import privacyPolicy from '@/views/PrivacyPolicy'
import Terms from '@/views/TermsAndConditions'
import Calcerts from '@/views/CalcertsReg'
import Cheers from '@/views/CheersReg'
Vue.use(Router)

const siteRouter = new Router({
	mode: 'history',
	routes: [
		{ path: '/', redirect: '/services' },
		{
			path: '/services',
			name: 'Home',
			component: Home
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/do-it-yourself',
			name: 'Doit',
			component: Doit
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/full-service',
			name: 'FullServices',
			component: Full
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/resources',
			name: 'resources',
			component: Resources
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq',
			name: 'faq',
			component: Faq
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-a',
			name: 'faq-a',
			component: FaqA
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-b',
			name: 'faq-b',
			component: FaqB
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-c',
			name: 'faq-c',
			component: FaqC
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-d',
			name: 'faq-d',
			component: FaqD
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-e',
			name: 'faq-e',
			component: FaqE
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-f',
			name: 'faq-f',
			component: FaqF
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-g',
			name: 'faq-g',
			component: FaqG
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-h',
			name: 'faq-h',
			component: FaqH
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/faq-i',
			name: 'faq-i',
			component: FaqI
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/prices',
			name: 'prices',
			component: Prices
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/privacy-policy',
			name: 'privacyPolicy',
			component: privacyPolicy
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/cost-estimator',
			name: 'costEstimator',
			component: CostEstimator
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/contact-us',
			name: 'contact',
			component: ContactUs
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/compliance-wizard',
			name: 'ComplianceWizard',
			component: ComplianceWizard
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/terms-and-conditions',
			name: 'terms-and-conditions',
			component: Terms
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/resource-links',
			name: 'resource-links',
			component: ResourceLinks
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/cheers-reg',
			name: 'CheersReg',
			component: Cheers
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{
			path: '/calcerts-reg',
			name: 'CalcertsReg',
			component: Calcerts
			// The title and metatags exist in build/webpack.prod.config.js and starts in line 121
		},
		{ path: '*', component: NotFound }
	],
	scrollBehavior (to, from, savedPosition) {
		return { x: 0, y: 0 }
	}
})

siteRouter.beforeEach((to, from, next) => {
	// console.debug('router before each from', from, 'to', to)
	// Ensure config loads before accessing any route
	const config = Vue.e24Common.configService
	config.load(config.SITE).then((config) => {
		const findTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
		const findMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags)

		if (findTitle) document.title = findTitle.meta.title

		Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el))

		if (!findMeta) return next()

		findMeta.meta.metaTags.map(tagDef => {
			const tag = document.createElement('meta')

			Object.keys(tagDef).forEach(key => {
				tag.setAttribute(key, tagDef[key])
			})

			// We use this to track which meta tags we create, so we don't interfere with other ones.
			tag.setAttribute('data-vue-router-controlled', '')

			return tag
		}).forEach(tag => document.head.appendChild(tag))

		next()
	})
})

export default siteRouter



// WEBPACK FOOTER //
// ./src/router/index.js